module.exports = flarum.core.compat['helpers/nickname'];